import { Box, DataList, Flex, Text } from "@radix-ui/themes";

export function SelectedSku({ variant }: { variant: any }) {
  return (
    <Box my="2">
      <Flex align="center">
        <div className="min-w-16 min-h-16">
          <img
            key={variant.image}
            className="w-16 h-16 object-contain"
            src={variant.image}
          />
        </div>
        <Text
          size="1"
          weight="medium"
          as="p"
          className="mx-2"
          color="gray"
          highContrast
        >
          {variant.name}
        </Text>
      </Flex>
      <DataList.Root size="1" className="gap-1">
        <DataList.Item>
          <DataList.Label>Barcode:</DataList.Label>
          <DataList.Value>{variant.barcode}</DataList.Value>
        </DataList.Item>
        <DataList.Item>
          <DataList.Label>SKU ID:</DataList.Label>
          <DataList.Value>{variant.id}</DataList.Value>
        </DataList.Item>
      </DataList.Root>
    </Box>
  );
}
